import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { CampaignActivityForViewerLoadAction } from '../../domains/campaignActivityForViewer/actions.types';

import { CampaignActivityForViewerLifecycle } from './types';

const initialState: CampaignActivityForViewerLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<CampaignActivityForViewerLifecycle, CampaignActivityForViewerLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'CAMPAIGN_ACTIVITY_FOR_VIEWER.LOAD_PENDING':
      return setPending();
    case 'CAMPAIGN_ACTIVITY_FOR_VIEWER.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.campaignActivityForViewer);
    case 'CAMPAIGN_ACTIVITY_FOR_VIEWER.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
